module.exports = __webpack_public_path__ + "p5_img2.jpg?09ee8c10e7c4990d879aa2c7252f04ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img2.jpg
// module id = 118
// module chunks = 0